<template>
 <div class="m-2">
     <icon-view
        :has-border="false"
        icon="fas fa-info-circle color-orange"
        icon-size="1rem"
        title="Información Adicional"
        variant="custom-icon-view"
    />
    <br>
    <div class="row mb-5 custom-ml-4">
     <div class="col-md-3 col-sm-12">
        <div class="text-title regular text-gray">
          <span>Fecha de Creación:</span>
        </div>
        <span class="text-title">
        {{data.createDate | dateTime('hh:mm a')}}
        </span>
     </div>
    <div class="col-md-3 col-sm-12">
<div class="text-title regular text-gray">
          <span>Creado por:</span>
        </div>
        <span class="text-title">
        {{data.createBy}}
        </span>
    </div>
     <div class="col-md-3 col-sm-12">
<div class="text-title regular text-gray">
          <span>Fecha de Modificación:</span>
        </div>
        <span class="text-title">
        {{data.modifyDate|dateTime('hh:mm a')}}
        </span>
     </div>
          <div class="col-md-3 col-sm-12">
<div class="text-title regular text-gray">
          <span>Modificado por:</span>
        </div>
        <span class="text-title">
        {{data.modifyBy}}
        </span>
     </div>
    </div>
     <div class="row mb-5 custom-ml-4">
     <div class="col-md-3 col-sm-12">
        <div class="text-title regular text-gray">
          <span>Fecha de Sometido:</span>
        </div>
        <span class="text-title">
        {{data.submittedDate | dateTime('hh:mm a')}}
        </span>
     </div>
    <div class="col-md-3 col-sm-12">
<div class="text-title regular text-gray">
          <span>Sometido por:</span>
        </div>
        <span class="text-title">
        {{data.submittedBy | empty}}
        </span>
    </div>
     <div class="col-md-3 col-sm-12">
<div class="text-title regular text-gray">
          <span>Fecha de Completado:</span>
        </div>
        <span class="text-title">
        {{data.determinationDate| dateTime('hh:mm a')}}
        </span>
     </div>
          <div class="col-md-3 col-sm-12">
<div class="text-title regular text-gray">
          <span>Número de SIE:</span>
        </div>
        <span class="text-title">
        {{data.sieSchoolId}}
        </span>
     </div>
    </div>
 </div>
</template>

<script>
import IconView from 'icon-view';
export default {
  name: 'RlvAditionalInformation',
  components: {
   IconView
  },
  props:{
      data: {
      type: Object,
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-ml-4{
     margin-left: 30px;
}

</style>
